import { render, staticRenderFns } from "./DvBrowseFrame.vue?vue&type=template&id=1474bed0&scoped=true&"
import script from "./DvBrowseFrame.vue?vue&type=script&lang=ts&"
export * from "./DvBrowseFrame.vue?vue&type=script&lang=ts&"
import style0 from "./DvBrowseFrame.vue?vue&type=style&index=0&id=1474bed0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1474bed0",
  null
  
)

export default component.exports